export type NewsItemType = 'article' | 'video';

export interface NewsItem {
    id: string;
    type: NewsItemType;
    title: string;
    summary: string;
    date: string;
    image: string;
    /** YouTube video ID (from youtube.com/watch?v=ID or youtu.be/ID) */
    youtubeId?: string;
    location?: string;
}

export const NEWS_FILTERS = ['All', 'Stories', 'Videos'] as const;
export type NewsFilter = (typeof NEWS_FILTERS)[number];

export const newsItems: NewsItem[] = [
    {
        id: 'mobile-clinics-launched',
        type: 'article',
        title: 'Mobile Clinics Launched',
        summary:
            'PureMedify has launched new mobile clinics to bring quality healthcare to rural communities across Abia State and surrounding regions.',
        date: 'July 2024',
        location: 'Umunneochi, Abia State',
        image: '/image/news-mobile-clinic-africa.jpg',
    },
    {
        id: 'mobile-clinic-launch-event',
        type: 'video',
        title: 'Mobile Clinic Launch Event',
        summary:
            'Highlights from our mobile clinic launch — community outreach, patient registration, and the team on the ground serving rural families.',
        date: 'July 2024',
        location: 'Ngodo Isuochi',
        image: '/image/news-mobile-clinic-africa.jpg',
    },
    {
        id: 'csr-empowering-women',
        type: 'article',
        title: 'CSR: Empowering Women',
        summary:
            'Our latest CSR initiative focuses on empowering women in rural areas through health education, maternal care support, and community workshops.',
        date: 'June 2024',
        location: 'Abia State',
        image: '/image/news-women-health-africa.jpg',
    },
    {
        id: 'women-health-workshop-recap',
        type: 'video',
        title: 'Women\'s Health Workshop Recap',
        summary:
            'Watch highlights from our women\'s health education workshop — sessions on maternal care, nutrition, and community support networks.',
        date: 'June 2024',
        location: 'Rural Abia',
        image: '/image/news-women-health-africa.jpg',
    },
    {
        id: 'telemedicine-expansion',
        type: 'article',
        title: 'Telemedicine Expansion',
        summary:
            'PureMedify expands telemedicine services to more remote communities, connecting patients with doctors through digital health platforms.',
        date: 'May 2024',
        location: 'West Africa',
        image: '/image/news-telemedicine-africa.jpg',
    },
    {
        id: 'community-health-outreach',
        type: 'video',
        title: 'Community Health Outreach',
        summary:
            'Footage from our community health campaigns — screenings, health talks, and the impact of bringing care closer to underserved areas.',
        date: 'May 2024',
        location: 'Abia State',
        image: '/image/comm3.jpg',
    },
];

export const getYouTubeThumbnail = (youtubeId: string) =>
    `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

export const getYouTubeWatchUrl = (youtubeId: string) =>
    `https://www.youtube.com/watch?v=${youtubeId}`;

export const getYouTubeEmbedUrl = (youtubeId: string) =>
    `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
